export const MODAL_FORM_WIDTH = 500;
export const MOBILE_WIDTH_BREAKPOINT = '767px';
export const PASSWORD_MIN_LENGTH = 10;
export const INPUT_DATE_FORMAT = 'Y-MM-dd';
